import { ILogisticServiceProduct } from 'types/services';
import ToolServicesEdition from '../ToolServicesEdition/ToolServicesEdition';
import { IpillsByReference } from 'types/orders';

import './ToolEditionCard.scss';

interface IToolEditionCardProps {
  product: ILogisticServiceProduct;
  productIndex: number;
}

const ToolEditionCard = ({ product, productIndex }: IToolEditionCardProps) => {
  const pills =
    typeof product.product?.pills === 'string'
      ? (JSON.parse(product.product?.pills || '{}') as IpillsByReference)
      : product.product?.pills;

  return (
    <section className="toolEditionCard">
      <div className="toolInfo">
        <p className="toolNameWithPills">
          <span className="toolName">{product.product?.name}</span>
          {pills &&
            Object.values(pills).map(
              (pill: string | null) =>
                pill && (
                  <span key={pill} className="pill">
                    {pill}
                  </span>
                )
            )}{' '}
        </p>
        <p className="toolSku">
          <span className="toolSkuLabel">SKU: </span>
          <span className="toolSkuValue">{product.product?.sku}</span>
        </p>
        <ToolServicesEdition
          serial={product.product?.serial || ''}
          productIndex={productIndex}
        />
      </div>
    </section>
  );
};

export default ToolEditionCard;
